import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
// Misc Components

// Grid Module
import { LTGridModule } from '../features/grid/grid.module';
import { LTFilterModule } from '../features/filter/lt-filter.module';
import { LTErrorsModule } from '../features/lt-errors/lt-errors.module';
// Material
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { GridTemplateDirective } from '../features/grid/classes/grid-template.directive';
import { LTSharedUIModule } from '../features/lt-shared-ui/lt-shared-ui.module';
import { LTInputModule } from '../features/lt-input/lt-input.module';

@NgModule({
  imports: [
    RouterModule,
    MatListModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    DragDropModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    GridTemplateDirective,
    LTFilterModule,
    LTErrorsModule,
    LTGridModule,
    LTSharedUIModule,
    LTInputModule,
    //..uiModules,
  ],
  exports: [
    MatListModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    DragDropModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    GridTemplateDirective,
    LTFilterModule,
    LTErrorsModule,
    LTGridModule,
    LTSharedUIModule,
    LTInputModule,
    //..uiModules,
  ],
  providers: [
    
  ],
})
export class SharedModule { }
